import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  INTERNAL_LIAISON,
  INTERNAL_LIAISON_EMAIL,
  NGO_CONTACT_EMAIL,
  NGO_CONTACT_NAME,
  NGO_NAME,
  RELEVANCE_TO_COMPANY,
  REPRESENTATION_CATEGORY,
} from 'constants/formFields';
import { DEFAULT_OPTION, OPTION_CATEGORY_NOGS } from 'constants/general';
import getValueOption from 'utils/getOptionValue';
import { NGOCreateSchema } from 'utils/validators';

import type { TNGOCreateSchema } from 'utils/validators';
import type ICreateNGOForm from '../interfaces/ICreateNGOForm';

const useCreateNGOForm = ({ isPageLoading, selectedItem }: ICreateNGOForm) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty, isLoading },
    reset,
    setError,
    getValues,
    watch,
    setValue,
    resetField,
  } = useForm<TNGOCreateSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(NGOCreateSchema),
    defaultValues: {
      [NGO_NAME]: '',
      [REPRESENTATION_CATEGORY]: DEFAULT_OPTION,
      [NGO_CONTACT_NAME]: '',
      [NGO_CONTACT_EMAIL]: '',
      [RELEVANCE_TO_COMPANY]: '',
      [INTERNAL_LIAISON]: '',
      [INTERNAL_LIAISON_EMAIL]: '',
    },
  });

  useEffect(() => {
    if (selectedItem) {
      setValue(NGO_NAME, selectedItem.name);
      setValue(REPRESENTATION_CATEGORY, getValueOption(OPTION_CATEGORY_NOGS, selectedItem.representationCategory));
      setValue(NGO_CONTACT_NAME, selectedItem.contactName);
      setValue(NGO_CONTACT_EMAIL, selectedItem.contactEmail);
      setValue(RELEVANCE_TO_COMPANY, selectedItem.relevance);
      setValue(INTERNAL_LIAISON, selectedItem.internalLiaison);
      setValue(INTERNAL_LIAISON_EMAIL, selectedItem.internalLiaisonEmail);
    }
  }, [selectedItem, setValue]);

  useEffect(() => {
    if (!isPageLoading) {
      reset();
    }
  }, [reset, isPageLoading]);

  const fieldsName = Object.keys(getValues());

  return {
    control,
    handleSubmit,
    isDirty,
    reset,
    isLoading,
    setError,
    fieldsName,
    watch,
    setValue,
    resetField,
  };
};

export default useCreateNGOForm;
